export default {
  // RejectPhoneData
  selectClear: '선택 해제',
  rejectDataNumber: '수신거부 번호',
  customerNumber: '고객 번호',
  rejectDate: '수신거부일시',
  rejectDataState: '상태',
  memberClassification: '회원 구분',
  memberPhone: '고객 번호',
  title: '수신거부 해제',
  clearMsg: '수신거부를 해제하시겠습니까?',
  alertMsg: '해제할 항목을 선택해 주세요.',
};
